import { Button } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { useUserAuthContext } from "../../routes/routesAuths/userAuth";
import type { Action } from "./components/ActionList";
import { ActionList } from "./components/ActionList";
import styles from "./index.module.scss";

import { useConfigContext } from "@/app";
import { RootHeader } from "@/components/RootHeader";
import { useEffect } from "react";
import { UserInfo } from "./components/UserInfo";
import { useSetup } from "./logic";

const actions: Action[] = [
  {
    text: "实名认证",
    type: "user_centify",
    icon: "user-verify",
    extra: (data) => {
      if (data.user.isRealNameAuth) {
        return <span className={styles.primary_color}>已实名认证</span>;
      }

      if (data.user.auditRealNameStatus === 0) {
        return <span style={{color: "#6f5bfe"}}>审核中</span>;
      }

      if (data.user.auditRealNameStatus === 2) {
        return <span style={{color: "#fb2222"}}>审核不通过</span>;
      }
      return "";
    },
    extraArrow: (data) => !data.user.isRealNameAuth,
  },
  { text: "安全中心", type: "user_security", icon: "user-save" },
  {
    text: "用户名",
    type: "user_username",
    icon: "user-name",
    extra: (data) => data.user["userName"],
    extraArrow: (data) => !data.user["userName"],
  },
  { text: "登录设备", type: "user_devices", icon: "user-devices" },
  { text: "意见反馈", type: "user_report", icon: "user-advice" },
  { text: "异常交易行为以及平台处理措施", type: "panic", icon: "user-note" },
  {
    text: "关于我们",
    type: "about",
    icon: "user-aboutus",
    extra: (data) => {
      if (
        data.config &&
        data.config.appVersion &&
        data.config.appVersion.currentVersion
      ) {
        return `版本 ${data.config.appVersion.currentVersion}`;
      }
      return "";
    },
  },
];

const PREFIX = "";
export function PageUser() {
  const navigate = useNavigate();
  const store = useSetup();
  const { logout, user } = useUserAuthContext();
  const { config } = useConfigContext();
  const onAction = (type: string, payload: any) => {
    navigate(`${PREFIX}/${type}`);
  };

  useEffect(() => {
    store.fetchUserInfo();
  }, []);
  

  return (
    <article className={styles.page}>
      <section>
        <RootHeader title="用户中心" />
      </section>
      <section>
        <UserInfo user={user} />
      </section>
      <section>
        <ActionList
          actions={actions}
          user={user}
          config={config}
          onAction={onAction}
        />
      </section>
      <section className={styles.footer}>
        <Button className={styles.logout} onClick={() => logout()}>
          退出登录
        </Button>
      </section>
      <div className={styles.whitespce}></div>
    </article>
  );
}

export default PageUser;
